var map = {
	"./add_col_after.svg": "./src/assets/images/icons/add_col_after.svg",
	"./add_col_before.svg": "./src/assets/images/icons/add_col_before.svg",
	"./add_row_after.svg": "./src/assets/images/icons/add_row_after.svg",
	"./add_row_before.svg": "./src/assets/images/icons/add_row_before.svg",
	"./bold.svg": "./src/assets/images/icons/bold.svg",
	"./checklist.svg": "./src/assets/images/icons/checklist.svg",
	"./code.svg": "./src/assets/images/icons/code.svg",
	"./combine_cells.svg": "./src/assets/images/icons/combine_cells.svg",
	"./delete_col.svg": "./src/assets/images/icons/delete_col.svg",
	"./delete_row.svg": "./src/assets/images/icons/delete_row.svg",
	"./delete_table.svg": "./src/assets/images/icons/delete_table.svg",
	"./github.svg": "./src/assets/images/icons/github.svg",
	"./hr.svg": "./src/assets/images/icons/hr.svg",
	"./image.svg": "./src/assets/images/icons/image.svg",
	"./italic.svg": "./src/assets/images/icons/italic.svg",
	"./link.svg": "./src/assets/images/icons/link.svg",
	"./mention.svg": "./src/assets/images/icons/mention.svg",
	"./ol.svg": "./src/assets/images/icons/ol.svg",
	"./paragraph.svg": "./src/assets/images/icons/paragraph.svg",
	"./quote.svg": "./src/assets/images/icons/quote.svg",
	"./redo.svg": "./src/assets/images/icons/redo.svg",
	"./remove.svg": "./src/assets/images/icons/remove.svg",
	"./strike.svg": "./src/assets/images/icons/strike.svg",
	"./table.svg": "./src/assets/images/icons/table.svg",
	"./ul.svg": "./src/assets/images/icons/ul.svg",
	"./underline.svg": "./src/assets/images/icons/underline.svg",
	"./undo.svg": "./src/assets/images/icons/undo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/icons sync recursive ^\\.\\/.*\\.svg$";